import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

export function ModalCard({
  children,
  className,
  onClose,
  closeDisabled = false,
}: {
  children: React.ReactNode;
  className?: string;
  onClose?: () => void;
  closeDisabled?: boolean;
}) {
  return (
    <div
      className={cn(
        'relative flex w-[576px] max-w-full flex-col rounded-xl border border-border bg-background-subtle shadow-lg',
        className
      )}
    >
      <button
        type="button"
        aria-label="Close"
        disabled={closeDisabled}
        onClick={onClose}
        className="absolute right-4 top-4 z-10 flex items-center justify-center rounded-full bg-surface p-1.5 text-foreground hover:bg-surface-hover disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Icons.cancel className="size-4" />
      </button>
      {children}
    </div>
  );
}
